import { parse } from 'date-fns';
import { currentApiBaseUrl } from './environment';
import { RatingSummary } from './types';

export async function getRatings(): Promise<any> {
  try {
    const url = new URL(`${currentApiBaseUrl}/ratings/?countryCodes=`);
    const response = await fetch(url.href, {
      headers: { 'Content-Type': 'application/json' },
    });
    return await response.json();
  } catch (err) {
    console.error('Failed to fetch ratings:', (err as Error).message);
    throw err;
  }
}

export async function getRatingSummary(dealerId: string): Promise<RatingSummary> {
  try {
    const url = new URL(`${currentApiBaseUrl}/rating-summary/`);
    url.searchParams.append('dealerId', dealerId);
    const response = await fetch(url.href, {
      headers: { 'Content-Type': 'application/json' },
    });
    return await response.json();
  } catch (err) {
    console.error('Failed to fetch rating summary:', (err as Error).message);
    throw err;
  }
}

export async function getReviews(dealerId: string): Promise<any[]> {
  try {
    const url = new URL(`${currentApiBaseUrl}/reviews/`);
    url.searchParams.append('dealerId', dealerId);

    const response = await fetch(url.href, {
      headers: { 'Content-Type': 'application/json' },
    });
    const data = await response.json();

    const referenceDate = new Date();

    return data.map((entry: any) => {
      const dealerResponse = entry?.dealerResponse
        ? {
            text: entry.dealerResponse.text,
            date: parse(entry.dealerResponse.date, 'yyyy-MM-dd', referenceDate),
          }
        : null;

      return {
        id: entry?.id,
        categoryKey: entry?.categoryKey,
        rating: +entry?.rating,
        text: entry?.text,
        date: parse(entry?.date, 'yyyy-MM-dd', referenceDate),
        ...(dealerResponse && { dealerResponse }),
      };
    });
  } catch (err) {
    console.warn('Failed to fetch reviews:', (err as Error).message);
    throw err;
  }
}

export async function getFavoritePartner(
  authService: any,
  locale: { language: string; countryCode: string },
): Promise<any> {
  try {
    const favPartner = await authService.fetch('patp/v1/sprmyaudi/v1/pas/v1/favorite-partner', {
      resourceHostId: 'retailservices',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Accept-Language': `${locale.language}-${locale.countryCode.toUpperCase()}`,
        'x-market': `${locale.language}_${locale.countryCode}`,
      },
    });
    return favPartner?.json();
  } catch (e) {
    console.error('Error while gettin favorite partner.', { error: e });
    throw e;
  }
}
export async function setFavoritePartner(
  authService: any,
  locale: { language: string; countryCode: string } | undefined,
  kvpsId: string | undefined,
  country: string | undefined,
): Promise<any> {
  try {
    const favPartner = await authService.fetch('patp/v1/sprmyaudi/v1/pas/v1/favorite-partner', {
      resourceHostId: 'retailservices',
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Accept-Language': `${locale?.language}-${locale?.countryCode.toUpperCase()}`,
        'x-market': `${locale?.language}_${locale?.countryCode}`,
      },
      body: JSON.stringify({ tenant: country, kvpsid: kvpsId }),
    });
    return favPartner?.json();
  } catch (e) {
    console.error('Error while setting new favorite partner.', { error: e });
    throw e;
  }
}
